/* Shared reviewed catalogue pools. No tracking or automatic cart mutations.
 * Suggestions are rendered by Shopify from a reviewed pool, with live stock/cart exclusions.
 * Coffee keeps the theme's own variant + grinding picker; single-option goods use an explicit Add.
 */
if (!window.dpkCartExtrasLoaded) {
  window.dpkCartExtrasLoaded = true;
  const drawer = () => document.querySelector('cart-drawer');
  const pageSections = [...document.querySelectorAll('main .shopify-section')]
    .filter(el => /__(cart-items|cart-footer)$/.test(el.id)).map(el => el.id.replace('shopify-section-', ''));
  let syncing = false, dirty = false, timer;
  async function syncPage() {
    if (!pageSections.length) return;
    if (syncing) { dirty = true; return; }
    syncing = true;
    try {
      const url = new URL(location.href);
      url.searchParams.set('sections', pageSections.join(','));
      const response = await fetch(url, {credentials:'same-origin', cache:'no-store'});
      if (!response.ok) throw new Error('Cart read failed');
      const sections = await response.json();
      for (const id of pageSections) {
        if (!sections[id]) continue;
        const current = document.getElementById('shopify-section-' + id);
        const parsed = new DOMParser().parseFromString(sections[id], 'text/html');
        const updated = parsed.getElementById('shopify-section-' + id);
        if (current && updated) {
          const notes = [...current.querySelectorAll('cart-note input,cart-note textarea')].map(el => [el.id,el.value]);
          current.innerHTML = updated.innerHTML;
          notes.forEach(([id,value]) => {const field = document.getElementById(id);if(field)field.value=value;});
        }
      }
    } catch {
      document.querySelectorAll('.dpk-cart-extras__status').forEach(el => {
        el.textContent = 'Odśwież koszyk, aby zobaczyć aktualną listę produktów.';
      });
    } finally {
      syncing = false;
      if (dirty) { dirty = false; scheduleSync(); }
    }
  }
  function scheduleSync() { clearTimeout(timer); timer = setTimeout(syncPage, 180); }
  // Native quick-add and drawer quantity changes replace these server-rendered children.
  // Only observe child replacements, never our status text or page rerenders.
  const cartRoot = document.getElementById('CartDrawer');
  if (cartRoot && pageSections.length) new MutationObserver(records => {
    if (records.some(r => r.target === cartRoot || r.target.classList?.contains('drawer__inner') || r.target.id === 'CartDrawer-CartItems')) scheduleSync();
  }).observe(cartRoot, {childList:true, subtree:true});

  let pageNeedsDrawerRefresh = false;
  document.addEventListener('change', event => {
    if (event.target.closest('cart-items.cart-page') && event.target.dataset.index) pageNeedsDrawerRefresh = true;
  }, true);
  document.addEventListener('click', event => {
    if (event.target.closest('cart-items.cart-page cart-remove-button')) pageNeedsDrawerRefresh = true;
  }, true);
  if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, async () => {
    if (!pageNeedsDrawerRefresh) return;
    pageNeedsDrawerRefresh = false;
    try {
      const url = new URL(location.href);url.searchParams.set('sections','cart-drawer');
      const response = await fetch(url,{credentials:'same-origin',cache:'no-store'});
      if (!response.ok) return;
      const data = await response.json();
      const source = new DOMParser().parseFromString(data['cart-drawer'] || '', 'text/html').querySelector('#CartDrawer');
      if (source && cartRoot) cartRoot.innerHTML = source.innerHTML;
    } catch { /* Native cart page still displays the completed change. */ }
  });

  document.addEventListener('click', async event => {
    const button = event.target.closest('.dpk-cart-extras button');
    if (!button) return;
    const container = button.closest('.dpk-cart-extras');
    if (button.closest('quick-add')) {
      // Avoid stacking two drawers. The native picker reopens the cart after a successful add.
      if (container.dataset.location === 'drawer' && drawer()?.hasAttribute('open')) drawer().toggleDrawerClasses();
      return;
    }
    if (!button.dataset.dpkAdd || button.disabled) return;
    event.preventDefault();
    const status = container.querySelector('[role=status]');
    const label = button.textContent;
    button.disabled = true; button.textContent = 'Dodaję…'; status.textContent = '';
    try {
      const guard = window.DobraCalendarCart;
      if (!guard) throw Object.assign(new Error('unchecked'),{code:'unchecked'});
      const data = await guard.runAdd(button.dataset.productId, async () => {
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:button.dataset.dpkAdd,quantity:1}],sections:['cart-drawer','cart-icon-bubble'],sections_url:location.pathname})
        });
        const result = await response.json();
        if (!response.ok && !result.status) result.status = response.status;
        return result;
      });
      if (data.status) throw new Error(data.description || data.message || container.dataset.addUnconfirmed);
      for (const [id,selector] of [['cart-drawer','#CartDrawer'],['cart-icon-bubble','#cart-icon-bubble']]) {
        if (!data.sections?.[id]) continue;
        const parsed = new DOMParser().parseFromString(data.sections[id], 'text/html');
        const target = document.querySelector(selector), source = parsed.querySelector(selector);
        if (target && source) target.innerHTML = source.innerHTML;
      }
      if (container.dataset.location === 'page') {
        await syncPage();
        const heading = document.querySelector('cart-items .wt-cart__title');
        if (heading) { heading.tabIndex = -1; heading.focus({preventScroll:true}); }
      } else {
        document.querySelector('#CartDrawer .wt-cart__drawer__close')?.focus({preventScroll:true});
      }
      document.querySelectorAll('.dpk-cart-extras__status').forEach(el => {el.textContent = 'Produkt dodany do zamówienia.';});
     } catch (error) {
      const key = {add_calendar:'addCalendar',add_other:'addOther',mixed:'mixed',unchecked:'unchecked',add_unconfirmed:'addUnconfirmed'}[error.code];
      status.textContent = (key && container.dataset[key]) || error.message;
    }
    finally { window.DobraCalendarCart?.refresh(); if (button.isConnected) {button.disabled = false;button.textContent = label;} }
  });
}
